import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import store from './store/index'
import axios from 'axios'
import router from './router'
import LuckDraw from 'vue-luck-draw'
import TWebLive from 'tweblive'
import im from 'tim'
// import { showVconsole } from './utils/vconsole'
import './assets/css/animate.css'
import './assets/icon/iconfont.css'
import './assets/icon/tim.css'
import './assets/css/global.css'
import './assets/css/reset.css'
import './assets/css/border.css'

import VueClipboard from 'vue-clipboard2'

window.im = im
window.TWebLive = TWebLive
window.store = store
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.im = im
Vue.prototype.TWebLive = TWebLive
Vue.prototype.$store = store
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$alert = ElementUI.MessageBox.alert

Vue.use(LuckDraw)
Vue.use(ElementUI)

import wechatAuth from './plugins/wechatAuth'//微信登录插件
const qs = require('qs')
router.beforeEach((to, from, next) => {
  console.log('开始 router.beforeEach loginStatus/to.fullPath：' + store.state.shengyaUser.loginStatus + to.fullPath);
  let path = to.path;
  let url = window.location.href;
  let parseUrl = qs.parse(url.split('?')[1]);

  if (path.indexOf('login') > 0 || path.indexOf('scanningLogin') > 0) {
    next();
  } else {
    // PC 端扫码登录流程
    if (parseUrl.code && parseUrl.state === 'scanning_state') {
        handlePcLogin(parseUrl, url,next);
        return;
    }

    // 手机端登录流程，前提是没有进行 PC 端登录
    if (!store.state.pcLoginSuccess) {
      console.log('手机登录')
      if (store.state.shengyaUser.loginStatus == 0) {
        let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1; };
        if (isWeiXin()) {
          let loginUrl;
          if (parseUrl.code && parseUrl.state) {
            delete parseUrl.code;
            delete parseUrl.state;
            loginUrl = `${url.split('?')[0]}?${qs.stringify(parseUrl)}`;
          } else {
            loginUrl = url;
          }
          wechatAuth.redirect_uri = loginUrl;
          store.dispatch('setLoginStatus', 1);
          window.location.href = wechatAuth.authUrl;
        } else {
          alert('请在微信中打开该链接，谢谢');
        }
      } else if (
        store.state.shengyaUser.loginStatus == 1 ||
        (store.state.shengyaUser.loginStatus == 2 && (!store.state.shengyaUser.userInfo || !store.state.shengyaUser.userInfo.admin))
      ) {
        let parsedCodeUrl = qs.parse(to.fullPath.split('?')[1]);
        const options = {
          method: 'POST',
          data: qs.stringify({ code: parsedCodeUrl.code, p: parseUrl.p, url: url }),
          url: '/cob/loginCosByAuthCode.do'
        };
        axios(options)
          .then((res) => {
            if (res.data.result.success) {
              let shengyaUser = res.data.data;
              store.dispatch('setUserInfo', shengyaUser);
              store.dispatch('setLoginStatus', 2);
              next();
            } else {
              store.dispatch('setLoginStatus', 0);
              alert(res.data.result.message);
            }
          })
          .catch((err) => {
            store.dispatch('setLoginStatus', 0);
            console.error(err.message);
            alert('微信授权登录请求失败，请关闭网页等候10秒钟重试');
          });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});


Vue.use(wechatAuth, {appid: 'wx80f45a705a428987'})
function handlePcLogin(parseUrl,url,next) {
  const options = {
    method: 'POST',
    data:qs.stringify({code: parseUrl.code, p:parseUrl.p, url: url}),
    url:'/cob/loginCosPc.do'
  }
  axios(options).then(res => {
    if(res.data.result.success) {
      let shengyaUser = res.data.data;
      store.dispatch('setUserInfo', shengyaUser);
      store.dispatch('setLoginStatus', 2);
      store.dispatch('setPcLoginStatus', true)
      next()
    } else {
      alert('登录失败 ' + res.data.result.message);
    }
  })
  
}
//防多次点击，重复提交
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
